import { useQuery } from '@tanstack/react-query';

import {
  getLazyLoadingProvider,
  LazyLoadMode,
} from '@quintoandar/feature-flag-tools';
import { useEffect, useState } from 'react';

export const configCatProvider = process.env.CONFIGCAT_KEY
  ? getLazyLoadingProvider(process.env.CONFIGCAT_KEY, LazyLoadMode.HEAVY)
  : {
    isFeatureEnabled: (key, defaultValue) => Promise.resolve(defaultValue),
    getFeatureText: (key, defaultValue) => Promise.resolve(defaultValue),
  };

export const getKey = key => ['feature-flag', key];

const useFeatureFlag = ({ key, defaultValue }, options, identifier = null) =>
  useQuery(
    getKey(key),
    () =>
      identifier
        ? configCatProvider.isFeatureEnabled(key, defaultValue, { identifier })
        : configCatProvider.isFeatureEnabled(key, defaultValue),
    options,
  );

export const useFeatureFlagV2 = (key, defaultValue = false, context, options) => {
  const [isEnabled, setIsEnabled] = useState(defaultValue);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const getFeatureFlag = async () => {
      const isFeatureEnabled = await configCatProvider.isFeatureEnabled(
        key,
        defaultValue,
        context,
      );
      setIsEnabled(isFeatureEnabled);
      setIsReady(true);
    };

    getFeatureFlag();
  }, [context]);

  if (options?.withReady) {
    return { value: isEnabled, isReady };
  }

  return isEnabled;
};

export default useFeatureFlag;
